export default "__VITE_ASSET__BCarCi02__"